import React from 'react'
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'

// -------------- Styles --------------
// Botones de acción de un formulario: alineados a la derecha en pantallas grandes;
// en mobile quedan fijos al pie de la pantalla y ocupan todo el ancho.
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: theme.spacing(2),
      marginTop: theme.spacing(3),
      [theme.breakpoints.down('xs')]: {
        position: 'sticky',
        bottom: 0,
        zIndex: 2,
        // compensa el padding de PageContainer (16px) para que la barra llegue a los bordes
        margin: theme.spacing(3, -2, -2),
        padding: theme.spacing(1.5, 2),
        background: '#fafafa',
        borderTop: `1px solid ${theme.palette.divider}`,
        '& > *': {
          flex: 1,
        },
      },
    },
  }),
)

export default function FormActions({ children }: { children: React.ReactNode }) {
  const classes = useStyles()
  return <div className={classes.root}>{children}</div>
}
